import React from 'react';
import {Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid} from '@material-ui/core'



 

export default class InsertNewFurnizor extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
            numeFurnizor:'',
            numeFactura:''
         }
    }

     componentDidMount(){
  
    }


 static getDerivedStateFromProps(props, state) {
    // Any time the current user changes,
    // Reset any parts of state that are tied to that user.
    // In this simple example, that's just the email.

    // console.log('derivedprops :');
    if (props.isDisabled === true) {

        // console.log(' entered here:' );
      return {
        numeFurnizor: props.numeFurnizor,
       
      };
    }
    return null;
  }
   
     render() { 
       return (
          <div>
               <Dialog 
                 className="pm-alert-dialog"
                disableEscapeKeyDown
                 open={this.props.open}
                 onClose={this.props.dialogClose}
                 style={{zIndex:6000}}
                 >
                 <DialogActions >
                 <Fab  onClick={this.props.dialogClose} className="pm-round-button-dialog">
                                      <i className='material-icons pm-round-button-text-dialog'>close</i>
                            </Fab>
                 </DialogActions>
                 <h2 className='pm-dialog-alert-title'>{this.props.title}</h2>
                 <DialogContent style={{ width: '90%', margin: 'auto', overflow: 'hidden' }}>
                        <Grid style={{ width: '90%', margin: 'auto' }} container >
                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >


                                <TextField
                                    className="inputFocus loginTextField"
                                    disabled={this.props.isDisabled}
                                    style={{ width: '90%' }}
                                    label='Nume Furnizor'
                                    value={this.state.numeFurnizor || ''}
                                    onChange={(ev)=>{
                                        this.setState({numeFurnizor:ev.target.value})
                                    }}
                                    margin="normal"
                                />
                            </Grid>
                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >


                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label='Denumire Factura'
                                    value={this.state.numeFactura || ''}
                                    onChange={(ev)=>{
                                        this.setState({numeFactura:ev.target.value})
                                    }}
                                    margin="normal"
                                />
                            </Grid>
                        </Grid>
                </DialogContent>
                 <DialogActions className="pm-dialog-bottom-buttons">
                          
                          <Button  variant="outlined" onClick={this.props.add} className='pm-save-button'>
                                      Adauga
                          </Button>

                        
                          
                       
                      </DialogActions>
                       
                   
                 </Dialog>
         </div>
        );
       }
}